import { STALE_TIMES } from '@iheartjane/react-query-utils';
import { useQuery } from '@tanstack/react-query';

import { fetchGoldConfig } from './goldConfig.api';

export const useGoldConfig = ({ enabled = true } = {}) =>
  useQuery({
    enabled,
    queryFn: () => fetchGoldConfig(),
    queryKey: ['goldConfig'],
    staleTime: STALE_TIMES.long,
  });
